// Curated, category-specific Dream Couture galleries for the flagship designer
// landing pages. Dream Couture is the in-house couture line by Laura Rudovic.
// The bridal page shows the Dream Couture bridal collection; the prom, evening,
// mother-of-the-bride and sweet-16 pages show the Dream Couture evening wear
// collection (the same couture gowns styled for those occasions) with
// category-specific alt text for SEO.
//
// Keys must match the categoryKey used in src/data/designers.js.

const BASE = "https://base44.app/api/apps/6a45716f29f4beead6ccd3d2/files/mp/public/6a45716f29f4beead6ccd3d2/";

const BRIDAL = [
  { file: 'c9ccc9e0e_aria.jpg', name: 'Aria' },
  { file: '63d2e60bc_joy.jpg', name: 'Joy' },
  { file: '562db8ca1_lauren.jpg', name: 'Lauren' },
  { file: '503618efa_laurel.jpg', name: 'Laurel' },
  { file: '1c3ad9384_beatrice.jpg', name: 'Beatrice' },
  { file: 'cda2ac9ba_lala.jpg', name: 'Lala' },
  { file: 'ad48d7bb5_ashley.jpg', name: 'Ashley' },
  { file: 'dc8939f53_savanah.jpg', name: 'Savanah' },
];

const EVENING = [
  { file: '9d434f5c1_evening_01.jpeg', name: 'Coral Whisper' },
  { file: '7b93d63d5_evening_04.jpeg', name: 'Emerald Sovereign' },
  { file: '7b9c4f461_evening_06.jpeg', name: 'Noir Allure' },
  { file: 'eb2ce733d_evening_08.jpeg', name: 'Emerald Mermaid' },
  { file: 'db66a66ec_evening_10.jpeg', name: 'Noir Grande' },
  { file: '254a0f13c_evening_11.jpeg', name: 'Noir Siren' },
  { file: '31b76def5_evening_13.jpeg', name: 'Noir Halo' },
  { file: '9a4b839d1_evening_15.jpeg', name: 'Rose Couture' },
];

function bridalGallery() {
  return BRIDAL.map(g => ({
    url: BASE + g.file,
    alt: `Dream Couture ${g.name} bridal gown at Laura's Boutique & Bridal Westchester NY`,
  }));
}

function eveningGallery(label, seo = '') {
  return EVENING.map(g => ({
    url: BASE + g.file,
    alt: `Dream Couture ${g.name} ${label}${seo ? ` ${seo}` : ''} at Laura's Boutique & Bridal Westchester NY`,
  }));
}

export const DREAM_COUTURE_CATEGORY_GALLERIES = {
  bridal: bridalGallery(),
  prom: eveningGallery('couture prom dress', 'prom 2027'),
  'evening-gowns': eveningGallery('couture evening gown'),
  'mother-of-the-bride': eveningGallery('mother of the bride gown'),
  'sweet-16': eveningGallery('couture sweet 16 gown'),
};